import React from 'react'

const TacheId = () => {
  return (
    <div>TacheId</div>
  )
}

export default TacheId